import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config.js';
import { toApiError } from '../lib/api-error';

interface ParentSeedOutput {
  dataKey: string;
  name: string;
  credentialOutput?: { fieldMapping: Record<string, string> };
}

interface ParentSeedOutputsResponse {
  ok: boolean;
  parentSeedWorkflowId: string | null;
  outputs: ParentSeedOutput[];
}

/**
 * For a teardown workflow, fetches the parent seed workflow's declared outputs.
 * These are the variables available for use in the teardown flow.
 */
export function useParentSeedOutputs(workflowId: string | null, flowType: string | undefined) {
  return useQuery<ParentSeedOutputsResponse>({
    queryKey: ['workflow', workflowId, 'parent-seed-outputs'],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/workflows/${workflowId}/parent-seed-outputs`, {
        credentials: 'include',
      });
      if (!res.ok) throw await toApiError(res, 'Failed to fetch parent seed outputs');
      return res.json();
    },
    enabled: !!workflowId && flowType === 'teardown',
  });
}
